import { HttpError, ValidationError } from '../models';
import { Logger } from '../services';
import { promiseRetry } from '../util';

export interface AuthRequestInit extends RequestInit {
  authToken?: string;
  method?: string;
  body?: any;
}

export interface AuthFetch {
  <T>(input: RequestInfo | string, init?: AuthRequestInit): Promise<T | void>;
  destroy?(): void;
}

export interface JwtStore { get(): string | null; set(value: string): void; }

export function createAuthFetch(
  authTokenName: string,
  jwtStore: JwtStore,
  logger?: Logger
): AuthFetch {

  return async function <T>(input: RequestInfo | string, init: AuthRequestInit = {}): Promise<T | void> {
    const authToken = init.authToken || (jwtStore && jwtStore.get());
    const requestInit = { headers: {}, ...init };

    if (authToken) {
      requestInit.headers[authTokenName] = authToken;
    }

    if (init.body) {
      if (typeof init.body === 'object') {
        requestInit.headers['content-type'] = 'application/json';
        requestInit.body = JSON.stringify(init.body);
      }
    }

    return promiseRetry(
      async () => {
        const response = await fetch(input, requestInit);

        return parseResponse(response);
      },
      logger
    );
  };
}

async function parseResponse(response: Response) {
  const contentType = response.headers.get('content-type') || 'text/html';
  const isJson = contentType.includes('application/json');

  if (response.status >= 400) {
    await throwError(response, isJson);
  }

  return isJson ? response.json() : response.text();
}

async function throwError(response: Response, isJson: boolean) {
  let json: any;
  let messages: string[] = [];
  let message = 'Error';

  if (isJson) {
    try {
      json = await response.json();

      if (json.messages && json.messages.length > 0) {
        messages = json.messages;
        message = JSON.stringify(messages);
      } else {
        message = json.message || JSON.stringify(json) || message;
        messages = [message];
      }
    } catch (err) {
      message = 'Failed to parse error JSON';
    }
  } else {
    message = await response.text() || 'Error';
  }

  switch (response.status) {
    case 400:
      throw new ValidationError(messages);
    default:
      throw new HttpError(response.status, message, json && json.stack);
  }
}



// WEBPACK FOOTER //
// ./src/gs-core/common/auth/authFetch.ts